import axios from 'axios';
import { IBillingDataDTO } from '../model/billing-data-dto.model';
import { IRestaurantDashboardDTO } from '../model/restaurant-dashboard-dto.model';
import { ISupportDashboardDTO } from '../model/support-dashboard-dto.model';

const baseRestaurantApiUrl = 'api/restaurant';
const baseSupportApiUrl = 'api/support';

export default class ReportService {
  public getRestaurantDashboardReport(id: number): Promise<IRestaurantDashboardDTO> {
    return new Promise<IRestaurantDashboardDTO>((resolve, reject) => {
      axios
        .get(`${baseRestaurantApiUrl}/dashboard-report/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getRestaurantBillingData(id: number): Promise<IBillingDataDTO> {
    return new Promise<IBillingDataDTO>((resolve, reject) => {
      axios
        .get(`${baseRestaurantApiUrl}/billingsdata/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getSupportDashboardReport(): Promise<ISupportDashboardDTO> {
    return new Promise<ISupportDashboardDTO>((resolve, reject) => {
      axios
        .get(`${baseSupportApiUrl}/dashboard-report`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
